module.exports = __webpack_public_path__ + "assets/034ea4f684d9a228a22ca1fe816f37b1.png";